var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavefront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 58.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.3,52.67H21a2.35,2.35,0,0,1-1.86-.89L7.52,37.24a2.38,2.38,0,0,1-.45-2.06l4.42-17.8a2.42,2.42,0,0,1,1.25-1.56L29.12,7.61a2.39,2.39,0,0,1,2.12,0l16.59,8.22a2.34,2.34,0,0,1,1.26,1.58l4.22,17.8a2.38,2.38,0,0,1-.46,2L41.15,51.79A2.37,2.37,0,0,1,39.3,52.67ZM21,50.22H39.26L50.91,35.73,46.71,18,30.19,9.82,13.87,18,9.46,35.74Z",
    style: {
      fill: "#238fcf"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "51.22 12.55 53.3 10.84 31.41 0 31.41 2.74 51.22 12.55",
    style: {
      fill: "#1bbfd3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.2 38.02 0.53 38.61 15.8 57.77 17 55.34 3.2 38.02",
    style: {
      fill: "#79bf43"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.95 2.75 28.95 0.01 7.35 10.84 9.37 12.58 28.95 2.75",
    style: {
      fill: "#1bbfd3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.91 14.56 5.83 12.77 0 36.21 2.68 35.62 7.91 14.56",
    style: {
      fill: "#1d4489"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.71 35.63 60.38 36.22 54.83 12.77 52.71 14.51 57.71 35.63",
    style: {
      fill: "#1d4489"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.16 38.02 43.21 55.37 44.4 57.8 59.83 38.61 57.16 38.02",
    style: {
      fill: "#79bf43"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.21 56.4 18.01 58.86 42.18 58.86 40.98 56.4 19.21 56.4",
    style: {
      fill: "#1bbfd3"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavefront);
export default __webpack_public_path__ + "static/media/wavefront.fbd68c8e31843291a855dd4cad86ff9e.svg";
export { ForwardRef as ReactComponent };